export default {
  "config": {
    "trial": "driving",
    "id": "percent-improvement",
    "type": "design",
    "title": "Participants with Improved vs Impaired Driving Performance with Solriamfetol Treatment Compared with Placebo at 2 Hours Post-Dose, %<sup>29</sup><sup>,a,b</sup>",
    "footnotes": [
      "<sup>a</sup>Improvement and impairment based on difference in SDLP for solriamfetol vs placebo at each threshold. Percentages with improvement and impairment were compared using a McNemar test to detect an asymmetry in the distribution of the change in driving performance.",
      "<sup>b</sup>Data shown for 2 hours post-dose; differences at 6 hours post-dose were smaller at each threshold (% with improvement ≥% with impairment at 5 of 6 thresholds)."
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "driving",
    "id": "percent-improvement",
    "data-type": "design",
    "title": "Participants with Improved vs Impaired Driving Performance with Solriamfetol Treatment Compared with Placebo at 2 Hours Post-Dose, %<sup>29</sup><sup>,a,b</sup>",
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-a",
      "footnote-b"
    ],
    "footnote-a": "<sup>a</sup>Improvement and impairment based on difference in SDLP for solriamfetol vs placebo at each threshold. Percentages with improvement and impairment were compared using a McNemar test to detect an asymmetry in the distribution of the change in driving performance.",
    "footnote-b": "<sup>b</sup>Data shown for 2 hours post-dose; differences at 6 hours post-dose were smaller at each threshold (% with improvement ≥% with impairment at 5 of 6 thresholds)."
  }
};